import { RichTextBlock } from 'prismic-reactjs'
import React from 'react'
import usePageContext from '../../../hooks/usePageContext'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import AccountsSection from '../../sections/AccountsSection'
import AccountsTabsSection from '../../sections/AccountsTabsSection'
import { AccountsTabsItemProps } from '../../organisms/Tabs/AccountsTabs/types'
import { PricingTabsSliceProps } from './types'
import { useMemo } from 'react'
import { mapButtonProps } from '../../atoms/Button/utils'

const PricingTabsSlice: React.FC<PricingTabsSliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { pt_title, pt_is_heading_main, pt_subtitle, pt_description, pt_hide_tabs } = primary || {}

  const { group } = usePageContext()

  const data: AccountsTabsItemProps[] = useMemo(
    () =>
      items.map((item, index) => {
        const { tab_title = '', tab_image, content_document } = item || {}
        const { pricing_plans = [] } = content_document?.document?.data || {}

        return {
          id: `${index}`,
          tabKey: `${index}`,
          tabIcon: tab_image,
          title: tab_title,
          item: pricing_plans.map((plan, index) => {
            const {
              plan_title = '',
              plan_price = '',
              plan_description = '',
              plan_features,
              cta_link,
              cta_text = '',
              cta_type,
              cta_is_centered,
              cta_caption,
              cta_caption_mobile_size,
              cta_caption_desktop_size
            } = plan || {}

            return {
              key: `${index}`,
              title: plan_title,
              price: plan_price,
              description: plan_description,
              list: (plan_features?.raw || []).map((feature: RichTextBlock, index) => ({
                key: `${index}`,
                title: feature?.text || '',
                isAwarded: feature?.spans?.some((span) => span?.data?.label === 'is-awarded')
              })),
              cta: mapButtonProps(
                cta_type,
                cta_text,
                resolvePrismicLink(cta_link, group),
                cta_link?.link_type,
                cta_caption,
                cta_caption_mobile_size,
                cta_caption_desktop_size,
                cta_is_centered
              )
            }
          })
        }
      }),
    [items, group]
  )

  if (pt_hide_tabs) {
    return (
      <AccountsSection
        heading={pt_title?.text}
        isMainHeading={pt_is_heading_main}
        subheading={pt_subtitle?.text}
        description={pt_description?.text}
        isSubheadingBold
        isHeadingGreen
        inner="inners.primary"
        paddingTop={['38px', '', '90px']}
        paddingBottom={['50px', '', '30px']}
        headingPadding={['20px', '', '40px']}
        data={data[0]?.item}
      />
    )
  }

  return (
    <AccountsTabsSection
      heading={pt_title?.text}
      isMainHeading={pt_is_heading_main}
      subheading={pt_subtitle?.text}
      description={pt_description?.text}
      isSubheadingBold
      isHeadingGreen
      inner="inners.fullWidth"
      paddingTop={['38px', '', '90px']}
      paddingBottom={['50px', '', '30px']}
      headingPadding={['20px', '', '40px']}
      data={data}
    />
  )
}

export default PricingTabsSlice
